import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { EventService } from '../common/service/event.service';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { NgForm } from '@angular/forms';
import { GlobalConstants } from '../common/GlobalConstants ';
@Component({
  selector: 'app-employee-mangement-list',
  templateUrl: './employee-mangement-list.component.html',
  styleUrls: ['./employee-mangement-list.component.css']
})
export class EmployeeMangementListComponent extends BaseListCtl {
  departmentList =null;
  unitList = null;
  display='none';

  userContext = JSON.parse(localStorage.getItem(GlobalConstants.getKey('userContext')));
  authKey=JSON.parse(localStorage.getItem(GlobalConstants.getKey('skey')));
  orgId=JSON.parse(localStorage.getItem(GlobalConstants.getKey('orgId')));
  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute, private eService: EventService) {
    super(locator.endpoints.EMPLOYEEMANAGEMENT, locator, route);
  }

  public sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));

  openDRCode(keyQR){
    console.log("Open URL EMPLOYE", keyQR)
    alert("#### "+ keyQR);
  }

  populateForm(form, data) {
    super.populateForm(form, data);
    form.id = data.id;
    form.name = data.name;
    form.unitId = data.unitId;
    form.unitName = data.unitName;
    form.departmentId = data.departmentId;
    form.departmentName = data.departmentName;
    form.firstName = data.firstName;
    form.lastName = data.lastName;
    form.role= data.role  ;
    form.address = data.address;
    form.mobile = data.mobile;
    form.mobileId = data.mobileId;
    form.loginId = data.loginId;
    form.password = data.password;
    form.userId = data.userId;
    form.userName = data.userName;
    form.empId = data.empId;
    form.shiftId = data.shiftId;
    form.shiftName = data.shiftName;
    form.status = data.status;
    form.designation = data.designation;
    form.skey=data.skey;
    form.imageId= data.imageId;
    form.orgName = data.orgName;
    form.orgId = data.orgId;
    console.log('----->', data);
  }


  isLogin = false;


  saveOrupdateEmp(){
    var _self = this;
    console.log('--------id------',_self.form.data.id)
    _self.form.data['login'] = _self.form.data['loginId']
    if(_self.form.data.id>0)
    {
      _self.updateEmp();
    }
    else{
      _self.signUpEmp();
    }
  
  }

  updateEmp() {
    var _self = this;
    console.log("In updateEmp().....")
    if(_self.userContext.orgId == 22)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.NCS_ORGID;
    }
    if(_self.userContext.orgId == 73)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.POWERTECH_ORGID;
    }
    if(_self.userContext.orgId == 66)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.RAYS_ORGID;
    }
    if(_self.userContext.orgId == 85)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.CreatEV_Solutions ;
    }
   
    _self.form.data["appId"] = _self.locator.endpoints.PNAC_APPID;   
    _self.form.data["orgName"] = _self.userContext.orgName;
    console.log("org id in emp----",_self.form.data["orgId"]);
    _self.form.data["role"] = "Employee"
    
    console.log(_self.form);
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.EMPLOYEEMANAGEMENT, "updateEmp/" +_self.authKey);
    console.log("url====",url)
    this.locator.http.post(url, this.form.data, function (res, error) {

       console.log('response', res);
      _self.form.message = '';
      _self.form.inputerror = {};

      //console.log("1");
      if(res.success){
        _self.isLogin = true;
      }
      _self.form.error = res.success;
      _self.form.message = 'Updated Successfully';
      _self.search();
      _self.form.inputerror = res.result.inputerror;
    });
  }
 
  signUpEmp() {
    var _self = this;
    var _self = this;
    console.log("In SignUpEmp().....")
    console.log("I am Virendra ", _self.userContext.orgId);
    if(_self.userContext.orgId == 22)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.NCS_ORGID;
    }
    if(_self.userContext.orgId == 73)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.POWERTECH_ORGID;
    }
    if(_self.userContext.orgId == 66)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.RAYS_ORGID;
    }
    if(_self.userContext.orgId == 74)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.MnM_Group_Of_Companies;
    }
    if(_self.userContext.orgId == 77)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.Airtel_ANG;
    }
    if(_self.userContext.orgId == 85)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.CreatEV_Solutions ;
    }
    
    _self.form.data["appId"] = _self.locator.endpoints.PNAC_APPID;   
    _self.form.data["orgName"] = _self.userContext.orgName;
    console.log("org id in emp----",_self.form.data["orgId"]);
    _self.form.data["role"] = "Employee"
    
    console.log(_self.form);
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.EMPLOYEEMANAGEMENT, "/signUpEmp");
    console.log("url====",url)
    this.locator.http.post(url, this.form.data, function (res, error) {

       console.log('response', res);
      _self.form.message = '';
      _self.form.inputerror = {};

      //console.log("1");
      if(res.success){
        _self.isLogin = true;
        _self.search();
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
      _self.form.inputerror = res.result.inputerror;
    });
  }
 

  preloadByUnit(dID) {
    console.log("======preloadByUnit========");
    if (dID != null && dID >= 0) {
  
      var _self = this;
      _self.departmentList = null;
      _self.unitList = null;
      // _self.form.data["employeeId"] == null;
      var searchParam = { "unitId": dID }
      let depUrl = _self.endpoint + "/preloadByUnit/" + dID;
      console.log(_self.endpoint, " Search Form ", searchParam);
      this.locator.http.get(depUrl, function (res, error) {
  
        if (res.success) {
          console.log("===" + res.result.depList)
          _self.departmentList = res.result.depList;
          _self.unitList = res.result.unitList;
          // _self.form.data["unitId"] = res.result.unitId;
          // _self.form.data["gateId"] = res.result.gateId;
          // _self.form.data["unitName"] = res.result.unitName;
          // _self.form.data["gateName"] = res.result.gateName;
          console.log("List Size", _self.departmentList);
        }
  
      });
  
    }
  }
  
  isMnm() {
    let check = localStorage.getItem('orgId');
    if ((check == "74" && check != null)) {
      return true;
    } else {
      return false;
  }
}

title = 'FormValidation';  
 mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";  
isValidFormSubmitted = false;  
onFormSubmit(form: NgForm) {  
  this.isValidFormSubmitted = false;  
  if (form.invalid) {  
     return;  
  }  
  this.isValidFormSubmitted = true;  
  form.resetForm();  
} 
emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  
  
  iseValidFormSubmitted = false;  
    oneFormSubmit(form: NgForm) {  
    this.iseValidFormSubmitted = false;  
    if (form.invalid) {  
       return;  
    }
    this.iseValidFormSubmitted = true;  
    form.resetForm();  
 } 

 openModalDialog(){
  this.display='block'; //Set block css
}

}
